<template>
  <div class="live-page">
    <el-card shadow="never" style="margin-bottom: 16px">
      <template #header>
        <div class="header-bar">
          <span>📺 直播监控（开播雷达）</span>
          <div>
            <el-button size="small" type="primary" :loading="refreshing" @click="refreshNow">🔍 立即扫描开播</el-button>
            <el-button size="small" :loading="loading" @click="loadData">🔄 刷新列表</el-button>
          </div>
        </div>
      </template>
      <el-alert type="info" :closable="false" show-icon
        title="每 15 分钟自动扫描 68 个关注博主，发现开播自动进直播间采集弹幕"
        description="点击博主名/直播间链接可实时查看直播间状况；直播间信息与视频评论（意向用户）分开标注。" />
      <el-alert type="warning" :closable="false" show-icon style="margin-top:12px"
        title="本功能需配合 MuMu 模拟器使用（模拟器内登录抖音账号后自动采集弹幕）">
        <template #default>
          <el-link type="primary" @click="goHelp">📥 查看 MuMu 模拟器下载与使用教程 →</el-link>
        </template>
      </el-alert>
    </el-card>

    <!-- 统计 -->
    <el-row :gutter="12" style="margin-bottom: 16px">
      <el-col :span="6"><el-card shadow="hover" class="stat"><div class="num">{{ total }}</div><div class="label">发现直播间（累计）</div></el-card></el-col>
      <el-col :span="6"><el-card shadow="hover" class="stat"><div class="num" style="color:#67c23a">{{ stats.found || 0 }}</div><div class="label">🟢 开播中/待采集</div></el-card></el-col>
      <el-col :span="6"><el-card shadow="hover" class="stat"><div class="num" style="color:#409eff">{{ stats.done || 0 }}</div><div class="label">✅ 已采集完成</div></el-card></el-col>
      <el-col :span="6"><el-card shadow="hover" class="stat"><div class="num" style="color:#e6a23c">{{ liveCount }}</div><div class="label">🔴 当前开播中</div></el-card></el-col>
    </el-row>

    <el-card shadow="never">
      <template #header><span>📋 直播间记录（{{ rooms.length }} 条）</span></template>
      <el-table :data="rooms" v-loading="loading" stripe size="small">
        <el-table-column label="博主/直播间" min-width="160">
          <template #default="{ row }">
            <el-link v-if="row.room_url" type="primary" :href="row.room_url" target="_blank">
              {{ row.blogger_name || row.room_name || row.room_url }}
            </el-link>
            <span v-else>{{ row.blogger_name || row.room_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="在线人数" width="90" align="center">
          <template #default="{ row }">{{ row.viewers || '-' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="110" align="center">
          <template #default="{ row }">
            <el-tag :type="statusType(row.status)" size="small">{{ statusText(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="采集弹幕" width="90" align="center">
          <template #default="{ row }">{{ row.danmaku_count || 0 }}</template>
        </el-table-column>
        <el-table-column label="挖掘线索" width="90" align="center">
          <template #default="{ row }">{{ row.lead_count || 0 }}</template>
        </el-table-column>
        <el-table-column label="发现时间" width="140">
          <template #default="{ row }">{{ row.found_at }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template #default="{ row }">
            <el-button v-if="row.room_url" size="mini" type="primary" @click="openRoom(row.room_url)">▶ 查看直播</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'LiveMonitor',
  data() {
    return {
      loading: false,
      refreshing: false,
      rooms: [],
      stats: {}
    }
  },
  computed: {
    total() { return this.rooms.length },
    liveCount() { return this.rooms.filter(r => ['found', 'intercepting'].includes(r.status)).length }
  },
  mounted() { this.loadData() },
  methods: {
    goHelp() {
      this.$router.push('/help')
    },
    statusType(s) {
      return { found: 'danger', intercepting: 'warning', done: 'success', failed: 'info' }[s] || 'info'
    },
    statusText(s) {
      return { found: '🟢 开播中/待采集', intercepting: '⏳ 采集中', done: '✅ 已采集', failed: '❌ 失败' }[s] || s
    },
    async loadData() {
      this.loading = true
      try {
        const d = await api.get('/live/rooms')
        this.rooms = d.rooms || []
        this.stats = d.stats || {}
      } catch (e) {
        this.$message.error('加载失败: ' + e.message)
      } finally {
        this.loading = false
      }
    },
    async refreshNow() {
      this.refreshing = true
      try {
        const r = await api.post('/live/refresh')
        this.$message[ r.success ? 'success' : 'warning' ](r.detail || '扫描完成')
        this.loadData()
      } catch (e) {
        this.$message.error('扫描异常: ' + e.message)
      } finally {
        this.refreshing = false
      }
    },
    openRoom(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.header-bar { display: flex; align-items: center; justify-content: space-between; }
.stat { text-align: center; padding: 8px 0; }
.num { font-size: 26px; font-weight: 700; color: #409eff; }
.label { font-size: 13px; color: #909399; margin-top: 4px; }
</style>
